import IndustryActivity from "../../components/industryActivity/IndustryActivity.jsx";

export {
  INDUSTRIES_WITH_ACTIVITY_CONTENT as COMPANY_INDUSTRIES_WITH_ACTIVITY_CONTENT,
  industryHasActivityContent as companyIndustryHasActivityContent,
  isIndustryActivityAnswered as isCompanyIndustryActivityAnswered,
} from "../../utils/industryActivity.js";

const CompanyIndustryActivity = () => <IndustryActivity />;

export default CompanyIndustryActivity;
